// extracted by mini-css-extract-plugin
export default {"thumb":"slider_thumb__zJrxG","bar":"slider_bar__5XZrL","track":"slider_track__vvSdN"};